import { render } from "./BlackPlacemat.svg?vue&type=template&id=48b2b765"
const script = {}
script.render = render

export default script